import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

export function getFormGroup(): UntypedFormGroup {
    return new UntypedFormBuilder().group({
            firstname: [, [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
            lastname: [, [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
            defaultRoom: [],
            defaultSchool: [,[Validators.required]],
            title: []
    });
}
